import { EquipmentItem } from '@/backend/models/equipmentItem';
import { useEquipmentConnection } from '@/frontend/hooks/useEquipmentConnection';
import { InstrumentSelect } from './InstrumentSelect';

/**
 * The instrument column of the equipment table, on the run view.
 *
 * The same controls as the card on an equipment operation, which is the point:
 * a procedure's equipment is connected from whichever of the two the user
 * happens to be looking at, and both read the same store.
 */

export function InstrumentCell(props: { equipment: EquipmentItem }) {
  const { equipment } = props;
  const connection = useEquipmentConnection(equipment);

  return (
    <div style={{ minWidth: '14rem' }}>
      <InstrumentSelect equipment={equipment} connection={connection} />
    </div>
  );
}
